<template>
  <div class="panel panel-primary student-view__panel-billings">
    <div class="panel-body">
      <loading v-if="!billings" full-screen="false" size="small" />
      <div v-else-if="billings.length === 0" class="centralized-horizontal">
        <p class="centralized-horizontal-item">
          Não existem cobranças para este aluno
        </p>
      </div>
      <div v-else>
        <div v-if="billings.length > 1">
          <ul class="nav nav-tabs">
            <li v-for="(billing, index) in billings" :key="index"
                class="tabulated-list"
                :class="{ active: index === 0}"
                role="presentation"
            >
              <a class="billint-tab" data-toggle="tab" :href="`#billing-${billing.id}`">
                <strong v-if="isBillingCanceledOrInterrupted(billing)">({{ billing.translated_status }})</strong>
                {{ billing.course_name }}
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <section v-for="(billing, index) in billings"
                     class="tab-pane fade"
                     :class="{ 'in active': index === 0}"
                     :key="index"
                     :id="`billing-${billing.id}`"
            >
              <billing-view :billing="billing" />
            </section>
          </div>
        </div>
        <billing-view v-else :billing="billings[0]" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loading from 'components/Loading';
import BillingView from './BillingView';

export default {
  components: {
    BillingView,
    Loading,
  },
  computed: {
    ...mapState([
      'studentBillings',
    ]),
    billings() {
      if (this.studentBillings) {
        // TODO need to refactor
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return (this.studentBillings).sort(this.sortBilling);
      }
      return null;
    },
  },
  methods: {
    sortBilling(a, b) {
      if (!this.isBillingCanceledOrInterrupted(a) && this.isBillingCanceledOrInterrupted(b)) {
        return -1;
      }
      if (this.isBillingCanceledOrInterrupted(a) && !this.isBillingCanceledOrInterrupted(b)) {
        return 1;
      }
      return 0;
    },
    isBillingCanceledOrInterrupted(billing) {
      return ['canceled', 'interrupted'].includes(billing.status);
    },
  },
};
</script>
